import React from 'react';
import { Image } from '@noths/polaris-client-ribbons-design-system';

import type { Product, Sticker as StickerType } from '../../../../types/dontgiftguide';
import { ProductLabel } from '../../atoms/ProductLabel/ProductLabel';
import { Sticker } from '../../atoms/Stickers/Sticker/Sticker';
import * as styles from './WideProductTile.styles';

export interface WideProductTileProps {
  onLinkClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  product: Product;
  sticker: StickerType;
}

export const WideProductTile = ({ onLinkClick, product, sticker }: WideProductTileProps) => {
  if (!product) {
    return null;
  }

  return (
    <div css={styles.tile}>
      <a href={product.href} onClick={onLinkClick}>
        <div css={styles.imageContainer}>
          <Image src={product.image.original} css={styles.productImage} alt="" loading="lazy" />
          {sticker && (
            <div css={styles.stickerContainer}>
              <Sticker shape={sticker.shape} color={sticker.color} content={sticker.content} />
            </div>
          )}
        </div>
        <p css={styles.title}>
          <ProductLabel product={product} />
        </p>
      </a>
    </div>
  );
};
